export function usuariosFrentistasInRequest(params = {}) {
  return {
    type: '@usuariofrentista/USUARIOS_IN_REQUEST',
    payload: { params },
  };
}

export function findUsuarioFrentista(idusuario) {
  return {
    type: '@usuariofrentista/FIND_USUARIO',
    payload: { idusuario },
  };
}

export function failedRequest() {
  return {
    type: '@usuariofrentista/FAILED_REQUEST',
  };
}

export function deleteUsuario(idusuario, params) {
  return {
    type: '@usuariofrentista/DELETE_USUARIO',
    payload: { idusuario, params },
  };
}

export function updateUsuario(usuario, params) {
  return {
    type: '@usuariofrentista/UPDATE_USUARIO',
    payload: { usuario, params },
  };
}

export function storeUsuario(usuario, params) {
  return {
    type: '@usuariofrentista/STORE_USUARIO',
    payload: { usuario, params },
  };
}

export function successInRequest(
  usuarios,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@usuariofrentista/SUCCESS_IN_REQUEST',
    payload: { usuarios, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(usuario) {
  return {
    type: '@usuariofrentista/SUCCESS_REQUEST',
    payload: { usuario },
  };
}

export function successRemove(params) {
  return {
    type: '@usuariofrentista/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@usuariofrentista/RECORD_FILTERING',
    payload: { params },
  };
}
